import { Component,ViewChild ,Input,OnInit,OnDestroy } from '@angular/core';
import { IonicPage, NavController , MenuController, AlertController,ModalController, NavParams } from 'ionic-angular';

import { AuthService } from '../../providers/auth-service'
import { ClientesProvider } from '../../providers/clientes/clientes'
import { CompaniasProvider } from '../../providers/companias/companias'
import { MODO_DESCONECTADO,VERSION,NOMBRE_VERSION,DESCRIPCION_VERSION, NUBE_AWS } from "../../config/url.servicio"
import { ReportesPage } from '../../pages/reportes/reportes'
import { SeguridadPage } from '../../pages/seguridad/seguridad'
import { CajaPage } from '../../pages/caja/caja'
import { Storage } from '@ionic/storage'
import { MeseromeseroPage } from '../../pages/meseromesero/meseromesero'
import { VersionamientoPage } from '../../pages/versionamiento/versionamiento'
import { PushPage } from '../../pages/push/push'
import { PushProvider } from '../../providers/push/push'
import { UtilsProvider } from '../../providers/utils/utils'
import { DianFacturaElectronicaPage } from '../../pages/dian-factura-electronica/dian-factura-electronica';
import { Subject, Subscription } from 'rxjs';
import { switchMap, takeUntil } from 'rxjs/operators';
import { Observable } from 'rxjs/Observable';
import * as Fingerprint2 from 'fingerprintjs2';
import { CajaProvider } from '../../providers/caja/caja';
import { ParametrosGeneralesRedux } from '../../providers/redux/parametrosgenerales/parametrosgenerales';
import { ReservasPage } from '../reservas/reservas';
import { PoselectronicoPage } from '../poselectronico/poselectronico';
import { MenuPage } from '../menu/menu';
import { TenderoComponent } from '../../components/tendero/tendero';
import { ProveedoraPorProductoComponent } from '../../components/proveedora-por-producto/proveedora-por-producto';
import { ParqueaderosComponent } from '../../components/parqueaderos/parqueaderos';
import { ProveedoraPorProductoEquivalenciaComponent } from '../../components/proveedora-por-producto-equivalencia/proveedora-por-producto-equivalencia';
import { ElectronService } from 'ngx-electron';
import { fromPromise } from 'rxjs/observable/fromPromise';
import { CreditosComponent } from '../../components/creditos/creditos';
import { ProductosProvider } from '../../providers/productos/productos';
import { CajaverticalPage } from '../cajavertical/cajavertical';
import { CallcenterPage } from '../callcenter/callcenter';
import { UsuariosProvider } from '../../providers/usuarios/usuarios';
import { UsuariosService } from '../../providers/usuarios/usuarios.service';
import { inventarioPage } from '../inventario/inventario';
import { IaComponent } from '../../components/ia/ia';
@IonicPage()
@Component({
  selector: 'page-home',
  templateUrl: 'home.html',
  providers: [ AuthService,ParametrosGeneralesRedux,UsuariosService ]
})
export class HomePage implements OnInit, OnDestroy {
  @ViewChild('barCanvas') barCanvas;
  @ViewChild('barCanvasafn') barCanvasafn;
  @ViewChild('doughnutCanvas') doughnutCanvas;
  @ViewChild('lineCanvas') lineCanvas;
  barChart: any;
  doughnutChart: any;
  lineChart: any;
  data = []
  datos = ""
  labels = ""
  dataReal = [{valorReal:-1}]
  nombreCompaniaHeader:any=""
  nombreCargoHeader:any=""
  imagensplash: string = !MODO_DESCONECTADO ? "assets/imgs/3.jpg" : "assets/imgs/3_desconectado.jpg"
  logoanimacion: string = !MODO_DESCONECTADO ? "assets/imgs/logo.png" : "assets/imgs/logo_desconectado.png"
  imagenInforme: string = 'https://res.cloudinary.com/drqk6qzo7/image/upload/v1534470788/informes-min_agpenr.jpg'
  @Input('data') datas: any;
  @Input('events') events: any;
  timer:any;
  version:string = VERSION
  nombreVersion:string = NOMBRE_VERSION
  descripcionVersion:string = DESCRIPCION_VERSION
  datosPaginaHome:any[] = []
  recorrerVal = []
  push:boolean = false
  pushcantidad:number=0;
  timerVar;
  intervalSubscription: Subscription;
  ip:string = ''
  isLoading: boolean = false
  public cancelar$ = new Subject();
  mostrarBanner: boolean = false;
  mostrarBannerMensajeGeneral: boolean = false;
  mostrarBannerMensajeGeneralTexto: string = '';
  nuevaCaja:boolean = false
  usuarioSesion = [{"usuariosId":0,"codigousuario":"","nombreUsuario":"","cargosId":0,"nombreCargo":"","companiasId":0,"nombreCompania":"","colorAvatar":"#81c1fa"}]
  usuarios$: Observable<any[]>;
  usuarios: any[] = [];
  constructor(
    public navCtrl: NavController,
    public auth: AuthService,
    public menuControllers:MenuController,
    public utils:ClientesProvider,
    public storages:Storage,
    public servicioCompania:CompaniasProvider,
    public alertControllers:AlertController,
    public modalControllers:ModalController,
    public servicioPush:PushProvider,
    public mensajes:UtilsProvider,
    public servicio: CajaProvider,
    public utilsRedux: ParametrosGeneralesRedux,
    public _electronService:ElectronService,
    public servicioProductos:ProductosProvider,
    public usuariosProvider: UsuariosProvider,
    public navParams: NavParams
) {
  this.usuarios = this.navParams.get('usuarios');
  let mododesc = MODO_DESCONECTADO
  if(!mododesc){
   this.servicioCompania.devolverVarios(['nombreCompania','nombreCargo'])
   .then((val)=>{
     if(val){
      this.buscarPush()
       this.nombreCompaniaHeader = val['nombreCompania']
       this.nombreCargoHeader = val['nombreCargo']
     }
   })
   let ip = localStorage.getItem("ip");
   if(ip){
     this.ip = ip
   }
   this.datosPaginaHome = []

  this.datosPaginaHome = [
    {"nombre":"MenuPage","ruta":"MenuPage","titulo":"Menú","imagen":"https://afnarqui.s3.us-east-1.amazonaws.com/sancolombia/menu.png"},
    {"nombre":"CajaPage","ruta":"CajaPage","titulo":"Caja","imagen":"https://afnarqui.s3.us-east-1.amazonaws.com/sancolombia/caja.jpg"},
    {"nombre":"CajaverticalPage","ruta":"CajaverticalPage","titulo":"Caja v","imagen":"https://afnarqui.s3.us-east-1.amazonaws.com/sancolombia/caja.jpg"},
    {"nombre":"MeseromeseroPage","ruta":"MeseromeseroPage","titulo":"Pedidos salón","imagen":"https://afnarqui.s3.us-east-1.amazonaws.com/sancolombia/mesas.jpg"},
    {"nombre":"SeguridadPage","ruta":"SeguridadPage","titulo":"Seguridad","imagen":"https://afnarqui.s3.us-east-1.amazonaws.com/sancolombia/seguridad.jpg"},
    {"nombre":"IaComponent","ruta":"IaComponent","titulo":"🤖 Consultas IA","imagen":"https://afnarqui.s3.us-east-1.amazonaws.com/ia.jpg"},
    {"nombre":"ReportesPage","ruta":"ReportesPage","titulo":"Informes","imagen":"https://afnarqui.s3.us-east-1.amazonaws.com/sancolombia/informes.jpg"},
    {"nombre":"TenderoComponent","ruta":"TenderoComponent","titulo":"Tendero","imagen":"https://afnarqui.s3.us-east-1.amazonaws.com/sancolombia/tendero.jpg"},
    {"nombre":"CallcenterPage","ruta":"CallcenterPage","titulo":"Gestiones","imagen":"https://afnarqui.s3.us-east-1.amazonaws.com/sancolombia/gestiones.jpg"},
    {"nombre":"CreditosComponent","ruta":"CreditosComponent","titulo":"Créditos","imagen":"https://afnarqui.s3.us-east-1.amazonaws.com/sancolombia/creditos.webp"},
    {"nombre":"ReservasPage","ruta":"ReservasPage","titulo":"Reservas","imagen":"https://afnarqui.s3.us-east-1.amazonaws.com/sancolombia/reserva.jpg"},
    {"nombre":"DianFacturaElectronicaPage","ruta":"DianFacturaElectronicaPage","titulo":"Factura eletrónica","imagen":"https://afnarqui.s3.us-east-1.amazonaws.com/sancolombia/facturaelectronica.jpg"},
    {"nombre":"PoselectronicoPage","ruta":"PoselectronicoPage","titulo":"Pos electrónica","imagen":"https://afnarqui.s3.us-east-1.amazonaws.com/sancolombia/facturaci%C3%B3ndigital.png"},
    {"nombre":"ProveedoraPorProductoEquivalenciaComponent","ruta":"ProveedoraPorProductoEquivalenciaComponent","titulo":"Proveedora","imagen":"https://afnarqui.s3.us-east-1.amazonaws.com/sancolombia/proveedora.png"},
    {"nombre":"ParqueaderosComponent","ruta":"ParqueaderosComponent","titulo":"Parqueadero","imagen":"https://afnarqui.s3.us-east-1.amazonaws.com/sancolombia/parqueadero.jpg"},
  ]

  this.storages.get('notificaciones').then((val)=>{

    if(val){
      if(val == "S"){
        this.startTimer()
      }
    }
  })

  }else{
    this.navCtrl.setRoot('PrincipalPage');
    }
  }

  async ngOnInit() {
    let macLocal = await this.obtenerHuellaDigital()
    console.log('HuellaDigital', macLocal)
    this.buscarDatosIniciales()
    this.verificarPagos();
    this.verificarMensajeGeneral();
    this.cargarUsuarios()
  }

  async ionViewDidEnter() {
    this.cargarUsuarios()
  }

  async ionViewDidLoad() {
    this.buscarPush()
    this.verificarPagos();
    this.verificarMensajeGeneral();
    this.validarNuevaCaja()
    this.cargarUsuarios()
  }

  validarNuevaCaja() {
    let datosGenerales = localStorage.getItem('datosGenerales')
    let datosGeneralesJSON = JSON.parse(datosGenerales)
    if(datosGeneralesJSON && datosGeneralesJSON["nuevaCaja"]) {
      this.nuevaCaja = datosGeneralesJSON["nuevaCaja"].seleccion === 'S' ? true : false
    }
  }

  ngOnChanges(changes: {[propKey: string]: any}) {
    clearInterval(this.timer);
    this.executeEvents();
  }


  getData(): any {
    return this.data;
  }

  getEvents(): any {
    return this.events;
  }

  executeEvents() : void {
    let duration = (this.getData() && this.getData().duration) ? this.getData().duration : 10000;
    var events = null;

    if (this.getEvents()) {
      events = this.getEvents()['onRedirect'];
    }

    this.timer = setTimeout(function(){
      if (events) {
        events();
      }
    }, duration);
  }

  chat(){
        this.navCtrl.push('ChatPage');
  }



  abrirPaginaPermisos(){
    this.navCtrl.push('PermisosPage');
  }

  graficas(){
    this.navCtrl.push('GraficasPage');
  }

  sale(){
    this.navCtrl.push('DomiciliosappPage')
  }
  sqlBuscar(){
    this.navCtrl.push('SqlPage');
  }
  inventario(){
    this.navCtrl.push(inventarioPage);

  }
  exportarventas(){
    this.navCtrl.push('exportarventasPage');
  }
  ionViewWillLoad(){
    this.auth.authenticated()
    .then( autenticado => {
      if( !autenticado ) {
        this.navCtrl.setRoot('LoginPage');
      }
      this.buscarPush()

    })
    .catch( err => {
      this.navCtrl.setRoot('LoginPage');
    })
  }

  buscarPush(){

    this.storages.get('companiasId').then((val)=>{
      if(val){

        this.servicioPush.buscar(val).subscribe((data)=>{
          data = !NUBE_AWS ? data : data.data
          if(data[1][0].pushcantidad>0){

            this.pushcantidad = data[1][0].pushcantidad
          }else{
            this.pushcantidad = 0
          }
        },(error)=>{

          console.log(error)
        })
      }

    })
  }

  /**
   * @method cerrarSession este metodo limpia todas las variables de session y redirecciona al login
   */
  cerrarSession(){
    this.auth.logout()
    this.navCtrl.setRoot('LoginPage');
  }

  abrirPaginaDesdeMenu(ruta:any,nombre:any){
    this.storages.get('rut').then((val)=>{
      this.recorrerVal = JSON.parse(val)
      let data = 0

      for(var i=0;i < this.recorrerVal.length;i++){
        if(this.recorrerVal[i].nombre == nombre){
          data = -1
        }
      }

      if(data!=-1){
        // this.mostrarMensajes('No tiene permisos para ingresar','Verifique..')
        this.mensajes.mensajeMuestro('Seguridad','No tiene permisos para ingresar. Verifique', 'warning')
      }else{
       this.irArutas(ruta)
       this.menuControllers.close()
      }
    })
  }

  irArutas(ruta:any){
    switch(ruta){
      case "MenuPage":
      this.navCtrl.push(MenuPage)
      break;
      case "CajaPage":
        if(this.nuevaCaja) {
          this.navCtrl.push(CajaverticalPage, { parametro: 'atras' })
        } else {
          this.navCtrl.push(CajaPage)
        }
      break;
      case "CajaverticalPage":
         this.navCtrl.push(CajaverticalPage)
      break;
      case "ReportesPage":
      this.navCtrl.push(ReportesPage)
      break;
      case "SeguridadPage":
      this.navCtrl.push(SeguridadPage)
      break;
      case "MeseromeseroPage":
      this.navCtrl.push(MeseromeseroPage)
      break;
      case "DianFacturaElectronicaPage":
      this.navCtrl.push(DianFacturaElectronicaPage)
      break;
      case "ReservasPage":
      this.navCtrl.push(ReservasPage)
      break;
      case "PoselectronicoPage":
      this.navCtrl.push(PoselectronicoPage)
      break;
      case "TenderoComponent":
      this.navCtrl.push(TenderoComponent)
      break;
      case "ProveedoraPorProductoComponent":
      this.navCtrl.push(ProveedoraPorProductoComponent)
      break;
      case "ParqueaderosComponent":
      this.navCtrl.push(ParqueaderosComponent)
      break;
      case "ProveedoraPorProductoEquivalenciaComponent":
      this.navCtrl.push(ProveedoraPorProductoEquivalenciaComponent)
      break;
      case "CreditosComponent":
      this.navCtrl.push(CreditosComponent)
      break;
      case "CallcenterPage":
      this.navCtrl.push(CallcenterPage)
      break;
      case "IaComponent":
      this.navCtrl.push(IaComponent)
      break;
    }
  }
  mostrarMensajes(mensaje,advertencia) {
    let alert = this.alertControllers.create({
      title: advertencia,
      subTitle: mensaje,
      buttons: ['Ok']
    });
    alert.present()
  }

  verVersionamiento(item:any,imagen:boolean,canvas:boolean): void {
    let modal = this.modalControllers.create(VersionamientoPage,{ item, imagen,canvas })
    modal.present();

    modal.onDidDismiss(data => {
      if (data) {
        data.name = ""
        }
    })
}

startTimer(){
  this.timerVar = Observable.interval(600000).subscribe( x => {
      this.procesarDatosPush()
  })
}

procesarDatosPush(){
    this.storages.get('companiasId').then((val) => {

    this.servicioPush.procesarDatosPush(val)
    .debounceTime(3000)
    .subscribe((data)=>{

      let valor = data.json()
      console.log(valor)
      if(valor[1][0].pushcantidad>0){

        this.pushcantidad = valor[1][0].pushcantidad
      }
    },
     error=>{
       console.log(error)
     })
    })
}

pushMensaje(){
  this.push = !this.push
  let datos = []
  let modal = this.modalControllers.create(PushPage, { datos })
  modal.present();

  modal.onDidDismiss(data => {
   this.buscarPush()
  })
}
async iniciarImpresion(mac:any) {
  let macLocal = await this.obtenerHuellaDigital()
    if(macLocal == mac) {
      console.log('mac', macLocal)
      console.log('mac pc', mac)
      this.destruirSubscribe()
      this.startTimerImpresion()
    }
}

async buscarDatosIniciales() {
  let buscarParametrosGeneralesStore: any = await this.utilsRedux.buscarParametrosGeneralesStore()
  if(buscarParametrosGeneralesStore !== null && buscarParametrosGeneralesStore.parametrosGenerales !== null) {
    this.iniciarImpresion(buscarParametrosGeneralesStore.parametrosGenerales[0][0].mac)
  }else {
    let buscarParametrosGeneralesStore: any = await this.utilsRedux.buscarParametrosGeneralesStore()
    if(buscarParametrosGeneralesStore !== null && buscarParametrosGeneralesStore.parametrosGenerales !== null) {
      this.iniciarImpresion(buscarParametrosGeneralesStore.parametrosGenerales[0][0].mac)
    }
  }
}

startTimerImpresion(){
    this.intervalSubscription = Observable.interval(20000).subscribe( x => {
      this.imprimirMeseroEmpty(true)
})
}

imprimirMeseroEmpty(automatico: any){
 this.storages.get('companiasId').then((val) => {

  this.servicio.imprimirComandasMesasEmptyPorGestionAutomatico(val,automatico)
  .debounceTime(3000)
  .subscribe((data)=>{
    let valor = JSON.parse(data['_body']).data[0]
    if(valor != undefined && valor.length>0){
        this.reemprimirRecibo(JSON.parse(data['_body']).data)
    }
  },
   error=>{
     console.log(error)
   })
  })
}

reemprimirRecibo(valorImpresora) {
  for (let posicion: any = 0; posicion < valorImpresora.length; posicion++) {
let recibo = ''
    let mensajes = valorImpresora[posicion]
    for (let index:any = 0; index < mensajes.length; index++) {
        recibo += mensajes[index]['reciboCaja'] + '\n'
    }

    this.servicio.imprimirRecibo(recibo).subscribe(
        res => {
        },
        err => {
        }
    )
  }

}

destruirSubscribe() {
  if (this.intervalSubscription) {
    this.intervalSubscription.unsubscribe();
  }
}

async obtenerHuellaDigital() {
  return new Promise<void>((resolve, reject) => {
    Fingerprint2.get({}, (components) => {
      const values = components.map(component => component.value);
      const fingerprint = Fingerprint2.x64hash128(values.join(''), 31);
      return resolve(fingerprint);
    });
  });
}

ngOnDestroy() {
  clearInterval(this.timer);
  if (this.intervalSubscription) {
    this.intervalSubscription.unsubscribe();
  }
}

bajarVentasDiarias() {
  this.bajarVentas()
}

bajarVentas(){
  this.mensajes.mensajeConfirmacionDos('Bajar información','¿Está Seguro RECUERDE al bajar la información la clave de ingreso a SAN cambia y debe hablar con el adminstrador para poder ingresar al sistema ?','question','Si','No')
  .then((bajarinfo: boolean) => {
   if (bajarinfo) {
      this.storages.get('companiasId').then((companiasId) => {
        this.servicioCompania.guardarInformacionMododesconectadoRutaModoDesconectado(companiasId)
        .subscribe((data)=>{
          let items = JSON.parse(data['_body']).data
          let usuariosId = items[0][0].usuariosId
          this.storages.set('usuariosId',usuariosId)
          this.storages.get('usuariosId').then((usuariosId) => {
            this.bajarMap(items[0][0].companiasId, items[0][0].RUTA_MODO_DESCONECTADO,usuariosId)
          })

        },(error)=> {
          this.isLoading = false
          this.mensajes.mensajeMuestro('Descargar Información','No se lograron descargar los registros, intente luego ' + error,'error')
        })
      })
    }
      else {
        this.mensajes.mensajeMuestro('Bajar información','No se bajo la información','advertencia')
      }
    })
}

async devolverVariosAsync(keys: string[]) {
  const promises = keys.map(key => this.storages.get(key));
  const values = await Promise.all(promises);

  const result: {[key: string]: any} = {};

  values.forEach((value, index) => {
    result[keys[index]] = value;
  });

  return result;
}


async bajarMap(companiasId: any, ruta: string,usuarios:any) {
  this.isLoading = true
  let usuariosId = 0
  let responseUsuario = await this.devolverVariosAsync(['companiasId','usuariosId', 'nombreCargo','usuariosIdDesconect'])
  if(responseUsuario){
    usuariosId = responseUsuario['usuariosId'];
    companiasId = responseUsuario['companiasId'];
  }
  this.servicioCompania.guardarInformacionMododesconectadoVentasDiarias(companiasId)
  .pipe(
    takeUntil(this.cancelar$),
    switchMap((data: any) => {
      let items = JSON.parse(data['_body']).data
      items[0].push({'ruta':ruta})
      return fromPromise(this.servicioCompania.guardarInformacionMododesconectadoVentasDiariasExpress(items[0]))
      .pipe(
        switchMap((valores) => {
          if (valores !== undefined) {
            return this.servicioCompania.guardarInformacionMododesconectadoProductosLista(companiasId);
          } else {
            this.isLoading = false;
            this.cancelar$.next();
            return []; // Retorna un observable vacío si no hay valores
           }
          })
        )}),
    switchMap((data: any) => {
      let items = JSON.parse(data['_body']).data
      items[0].push({'ruta':ruta})
      return fromPromise(this.servicioCompania.guardarInformacionMododesconectadolistaProductosExpress(items[0]))
      .pipe(
        switchMap((valores) => {
          if (valores !== undefined) {
            return this.servicioCompania.guardarInformacionMododesconectadoClienteGenerico(companiasId);
          } else {
            this.isLoading = false;
            this.cancelar$.next();
            return []; // Retorna un observable vacío si no hay valores
           }
          })
        )}),
    switchMap((data: any) => {
      let items = JSON.parse(data['_body']).data
      items[0].push({'ruta':ruta})
      return fromPromise(this.servicioCompania.guardarInformacionMododesconectadoClienteGenericoExpress(items[0]))
      .pipe(
        switchMap((valores) => {
          if (valores !== undefined) {
            return this.servicioCompania.guardarInformacionMododesconectadoDenominaciones(companiasId);
          } else {
            this.isLoading = false;
            this.cancelar$.next();
            return []; // Retorna un observable vacío si no hay valores
           }
          })
        )}),
    switchMap( (data: any) => {
      let items = JSON.parse(data['_body']).data
      items[0].push({'ruta':ruta})
      return fromPromise(this.servicioCompania.guardarInformacionMododesconectadoDenominacionesExpress(items[0]))
      .pipe(
        switchMap((valores) => {
          if (valores !== undefined) {
            return this.servicioCompania.guardarInformacionMododesconectadoImprimirReciboCajaModoDesconectado(companiasId);
          } else {
            this.isLoading = false;
            this.cancelar$.next();
            return []; // Retorna un observable vacío si no hay valores
          }
          })
        )}),
    switchMap((data: any) => {
      let items = JSON.parse(data['_body']).data
      items[0].push({'ruta':ruta})
      return fromPromise(this.servicioCompania.guardarInformacionMododesconectadoReciboCajaExpress(items[0]))
      .pipe(
        switchMap((valores) => {
          if (valores !== undefined) {
            return this.servicioCompania.guardarInformacionMododesconectadoGrupos(companiasId);
          } else {
            this.isLoading = false;
            this.cancelar$.next();
            return []; // Retorna un observable vacío si no hay valores
          }
          })
        )}),
    switchMap((data: any) => {
      let items = JSON.parse(data['_body']).data
      items[0].push({'ruta':ruta})
      return fromPromise(this.servicioCompania.guardarInformacionMododesconectadoGruposExpress(items[0]))
      .pipe(
        switchMap((valores) => {
          if (valores !== undefined) {
            return this.servicioCompania.guardarInformacionMododesconectadoClientes(companiasId);
          } else {
            this.isLoading = false;
            this.cancelar$.next();
            return []; // Retorna un observable vacío si no hay valores
          }
          })
        )}),
    switchMap((data: any) => {
      let items = JSON.parse(data['_body']).data
      items[0].push({'ruta':ruta})
      return fromPromise(this.servicioCompania.guardarInformacionMododesconectadoClienteExpress(items[0]))
      .pipe(
        switchMap((valores) => {
          if (valores !== undefined) {
            return this.servicioCompania.guardarInformacionMododesconectadoProductos(companiasId);
          } else {
            this.isLoading = false;
            this.cancelar$.next();
            return []; // Retorna un observable vacío si no hay valores
          }
          })
        )}),
    switchMap((data: any) => {
      let items = JSON.parse(data['_body']).data
      items[0].push({'ruta':ruta})
      return fromPromise(this.servicioCompania.guardarInformacionMododesconectadoProductosExpress(items[0]))
      .pipe(
        switchMap((valores) => {
          if (valores !== undefined) {
            return this.servicioCompania.guardarInformacionMododesconectadoGruposProductos(companiasId);
          } else {
            this.isLoading = false;
            this.cancelar$.next();
            return []; // Retorna un observable vacío si no hay valores
          }
          })
        )}),
    switchMap((data: any) => {
      let items = JSON.parse(data['_body']).data
      items[0].push({'ruta':ruta})
      return fromPromise(this.servicioCompania.guardarInformacionMododesconectadoGruposProductosExpress(items[0]))
      .pipe(
        switchMap((valores) => {
          if (valores !== undefined) {
            return this.servicioCompania.guardarInformacionMododesconectadoProdutosPorGrupos(companiasId);
          } else {
            this.isLoading = false;
            this.cancelar$.next();
            return []; // Retorna un observable vacío si no hay valores
          }
          })
        )}),
    switchMap((data: any) => {
      let items = JSON.parse(data['_body']).data
      items[0].push({'ruta':ruta})
      return fromPromise(this.servicioCompania.guardarInformacionMododesconectadoProductosPorGruposExpress(items[0]))
      .pipe(
        switchMap((valores) => {
          if (valores !== undefined) {
            return this.servicioCompania.guardarInformacionMododesconectadoUsuarios(companiasId);
          } else {
            this.isLoading = false;
            this.cancelar$.next();
            return []; // Retorna un observable vacío si no hay valores
          }
          })
        )}),
    switchMap((data: any) => {
     let items = JSON.parse(data['_body']).data
      items[0].push({'ruta':ruta})
      return fromPromise(this.servicioCompania.guardarInformacionMododesconectadoUsuariosExpress(items[0]))
      .pipe(
        switchMap((valores) => {
          if (valores !== undefined) {
            return this.servicioCompania.guardarInformacionMododesconectadoCajaProductos(companiasId);
          } else {
            this.isLoading = false;
            this.cancelar$.next();
            return []; // Retorna un observable vacío si no hay valores
          }
          })
        )}),
    switchMap((data: any) => {
      let items = JSON.parse(data['_body']).data
      items[0].push({'ruta':ruta})
      return fromPromise(this.servicioCompania.guardarInformacionMododesconectadoCajaProductosExpress(items[0]))
      .pipe(
        switchMap((valores) => {
          if (valores !== undefined) {
            return this.servicioCompania.guardarInformacionMododesconectadoProductosCompanias(companiasId);
          } else {
            this.isLoading = false;
            this.cancelar$.next();
            return []; // Retorna un observable vacío si no hay valores
          }
          })
        )}),
    switchMap((data: any) => {
      let items = JSON.parse(data['_body']).data
      items[0].push({'ruta':ruta})
      return fromPromise(this.servicioCompania.guardarInformacionMododesconectadoProductosCompaniasExpress(items[0]))
      .pipe(
        switchMap((valores) => {
          if (valores !== undefined) {
            return this.servicioCompania.guardarInformacionMododesconectadoCompania(companiasId);
          } else {
            this.isLoading = false;
            this.cancelar$.next();
            return []; // Retorna un observable vacío si no hay valores
          }
          })
        )}),
    switchMap((data: any) => {
      let items = JSON.parse(data['_body']).data
      items[0].push({'ruta':ruta})
      return fromPromise(this.servicioCompania.guardarInformacionMododesconectadoCompaniasExpress(items[0]))
      .pipe(
        switchMap((valores) => {
          if (valores !== undefined) {
            return this.servicioCompania.guardarInformacionMododesconectadoformasDePagoModoDesconectado(companiasId);
          } else {
            this.isLoading = false;
            this.cancelar$.next();
            return []; // Retorna un observable vacío si no hay valores
          }
          })
        )}),
    switchMap((data: any) => {
      let items = JSON.parse(data['_body']).data
      items[0].push({'ruta':ruta})
      return fromPromise(this.servicioCompania.guardarInformacionMododesconectadoFormasDePagoExpress(items[0]))
      .pipe(
        switchMap((valores) => {
          if (valores !== undefined) {
            return this.servicioCompania.guardarInformacionMododesconectadobuscarparametrosGeneralesModoDesconectado(companiasId, usuariosId);
          } else {
            this.isLoading = false;
            this.cancelar$.next();
            return []; // Retorna un observable vacío si no hay valores
          }
          })
        )}),
    switchMap((data: any) => {
      let items = JSON.parse(data['_body']).data
      items[0].push({'ruta':ruta})
      return fromPromise(this.servicioCompania.guardarInformacionMododesconectadoParametrosGeneralesExpress(items[0]))
      .pipe(
        switchMap((valores) => {
          if (valores !== undefined) {
            return this.servicioCompania.guardarInformacionMododesconectadoMesas(companiasId);
          } else {
            this.isLoading = false;
            this.cancelar$.next();
            return []; // Retorna un observable vacío si no hay valores
          }
          })
        )}),
    switchMap((data: any) => {
      let items = JSON.parse(data['_body']).data
      items[0].push({'ruta':ruta})
      return fromPromise(this.servicioCompania.guardarInformacionMododesconectadoMesasExpress(items[0]))
      .pipe(
        switchMap((valores) => {
          if (valores !== undefined) {
            return this.servicioCompania.guardarInformacionMododesconectadoBuscarTurnosAppComandasVacio(companiasId);
          } else {
            this.isLoading = false;
            this.cancelar$.next();
            return []; // Retorna un observable vacío si no hay valores
          }
          })
        )}),
    switchMap((data: any) => {
      let items = JSON.parse(data['_body']).data
      items[0].push({'ruta':ruta})
      return fromPromise(this.servicioCompania.guardarInformacionMododesconectadoComandasVaciasExpress(items[0]))
      .pipe(
        switchMap((valores) => {
          if (valores !== undefined) {
            return this.servicioCompania.guardarInformacionMododesconectadoRutaModoDesconectado(companiasId);
          } else {
            this.isLoading = false;
            this.cancelar$.next();
            return []; // Retorna un observable vacío si no hay valores
          }
          })
        )})
  ).subscribe((productos: any) => {
    this.mensajes.mensajeMuestro('Descargar Información','los registros se descargaron con Éxito!','success')
    this.isLoading = false
    this.cancelar$.next();
  },
   err => {
    this.isLoading = false
    this.mensajes.mensajeMuestro('Descargar Información','No se lograron descargar los registros, intente luego','error')
    });
  }
  async verificarPagos() {
    let companiaId = await this.storages.get('companiasId')
    let response = await this.servicioProductos.buscarMorosos(companiaId)
    const parsedResponse = JSON.parse(response['_body']);
    let clienteIncumplido:boolean = false
    // Verificamos si "data" existe y contiene información
    if (parsedResponse.data && parsedResponse.data.length > 0) {
      const arrayProductos = parsedResponse.data[0]; // Accede al array dentro de "data"

      console.log("moroso:", arrayProductos);
      clienteIncumplido = arrayProductos.length > 0 ? true: false;
      setInterval(() => {
        if (this.mostrarBanner) {
          this.mostrarAlertaEstorbosa();
        }
      }, 30000);
    } else {
      clienteIncumplido = false;
    }

    if (clienteIncumplido) {
      this.mostrarBanner = true;
    } else {
      this.mostrarBanner = false;
    }
  }

  async verificarMensajeGeneral() {
    let companiaId = await this.storages.get('companiasId')
    let response = await this.servicioProductos.buscarMensajeGeneral(companiaId,'G')
    const parsedResponse = JSON.parse(response['_body']);
    let mensajeGeneral:boolean = false
    // Verificamos si "data" existe y contiene información
    if (parsedResponse.data && parsedResponse.data.length > 0) {
      const arrayProductos = parsedResponse.data[0]; // Accede al array dentro de "data"

      console.log("moroso:", arrayProductos);
      mensajeGeneral = arrayProductos.length > 0 ? true: false;
    } else {
      mensajeGeneral = false;
    }

    if (mensajeGeneral) {
      this.mostrarBannerMensajeGeneral = true;
      this.mostrarBannerMensajeGeneralTexto = parsedResponse.data[0][0].mensaje
    } else {
      this.mostrarBannerMensajeGeneral = false;
    }
  }

  mostrarAlertaEstorbosa() {
    this.mensajes.mensajeMuestro('¡Pago Pendiente!','Estás incumpliendo los pagos. Por favor regulariza la situación lo antes posible.','warning')
  }

  redirigirAWeb() {
    window.open('https://sancolombia.com/turno', '_blank');
  }

  openLink(url: string) {
    window.open(url, '_blank');
  }
  getIniciales(nombre: string): string {
    if (!nombre || nombre.trim() === '') {
      return ''; // Retorna una cadena vacía si el nombre no es válido
    }

    const palabras = nombre.trim().split(/\s+/); // Divide por espacios sin contar espacios extra
    return palabras.map(p => p[0]).join('').toUpperCase();
  }
  async cargarUsuarios() {
    if(!this.usuarios) {
      let usuariosId = 0
      let companiasId = 0
      let responseUsuario = await this.devolverVariosAsync(['companiasId','usuariosId'])
      if(responseUsuario){
        usuariosId = responseUsuario['usuariosId'];
        companiasId = responseUsuario['companiasId'];
      }
      let data = await this.usuariosProvider.buscarUsuariosPorId(companiasId, usuariosId);
      let response = JSON.parse(data['_body']).data[0];
      if (response !== null && response.length > 0) {
        if(response[0].companiasId !== 0) {
          localStorage.setItem('companiasId',response[0].companiasId)
        }
        this.usuarios = response;
        this.usuarios[0]['colorAvatar'] = this.generarColor(this.usuarios[0].nombreUsuario);

      }
   }
  }
  private generarColor(nombre: string): string {
    let hash = 0;
    for (let i = 0; i < nombre.length; i++) {
      hash = nombre.charCodeAt(i) + ((hash << 5) - hash);
    }
    return `#${('00000' + (hash & 0xffffff).toString(16)).slice(-6)}`;
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts